import React from 'react'
import { Link } from 'react-router-dom'

export const ASSISTANT_RIA_SUSPENDED = true

interface AssistantRIASuspensionNoticeProps {
  className?: string
  showContactLink?: boolean
}

export const AssistantRIASuspensionNotice: React.FC<AssistantRIASuspensionNoticeProps> = ({
  className = '',
  showContactLink = true,
}) => {
  if (!ASSISTANT_RIA_SUSPENDED) return null

  return (
    <div
      className={`rounded-xl border border-amber-300 bg-amber-50 p-5 sm:p-6 text-amber-950 shadow-sm ${className}`}
      role="status"
    >
      <div className="flex items-start gap-3">
        <span className="text-2xl shrink-0" aria-hidden>
          ⏸️
        </span>
        <div className="space-y-2">
          <p className="font-semibold text-lg text-amber-900">Assistant RIA temporairement suspendu</p>
          <p className="text-sm sm:text-base leading-relaxed text-amber-900/90">
            Chez RIA Facile, nous ne souhaitons pas rendre l&apos;utilisation de l&apos;assistant payante.
            Or les tokens du modèle d&apos;IA ont un coût élevé : l&apos;assistant RIA est donc suspendu pour le
            moment, le temps de trouver une solution durable.
          </p>
          {showContactLink && (
            <p className="text-sm text-amber-800/90">
              En attendant, vous pouvez consulter le{' '}
              <Link to="/consulter" className="font-medium text-[#774792] underline hover:no-underline">
                texte du Règlement IA
              </Link>
              , nos{' '}
              <Link to="/fiches-pratiques" className="font-medium text-[#774792] underline hover:no-underline">
                fiches pratiques
              </Link>{' '}
              ou nous écrire via le{' '}
              <Link to="/contact" className="font-medium text-[#774792] underline hover:no-underline">
                formulaire de contact
              </Link>
              .
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
